import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ReactTable from 'react-table';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import { DEFAULT_PAGE_SIZE } from 'stores/constants';
import ModalStore from 'stores/ModalStore';
import EmailsStore from 'stores/Emails/EmailsStore';

import TableSpinner from 'components/Spinner/TableSpinner';
import EmailViewModal from 'components/Modals/EmailView/EmailViewModal';

import style from './EmailsPage.module.scss';
import { config } from './columnsConfig';

@observer
class EmailsPage extends Component<WrappedComponentProps> {
  private _store = new EmailsStore();

  async componentDidMount() {
    await this._store.fetchEmails();
  }

  getTrProps(_, rowInfo) {
    return {
      onClick() {
        ModalStore.showModal(EmailViewModal, {
          id: rowInfo.original.id,
        });
      },
    };
  }

  render() {
    const { intl } = this.props;
    const {
      emails,
      pageCount,
      changeSort,
      changePageCurrent,
      loading,
    } = this._store;

    return (
      <main className={style.main}>
        {/* <div className={style.search__bar}>
          <SearchField onChange={changeFilter} value={searchTerm} />
        </div> */}

        <ReactTable
          className={style.table}
          manual
          pages={pageCount}
          defaultPageSize={DEFAULT_PAGE_SIZE}
          showPageSizeOptions={false}
          data={emails}
          showPagination={!!emails.length}
          minRows={0}
          onSortedChange={changeSort}
          loading={loading}
          LoadingComponent={TableSpinner}
          columns={config()}
          onPageChange={changePageCurrent}
          getTrProps={this.getTrProps}
          nextText={intl.formatMessage({ id: 'button.next' })}
          previousText={intl.formatMessage({ id: 'button.previous' })}
          pageText={intl.formatMessage({ id: 'table.pageText' })}
          ofText={intl.formatMessage({ id: 'table.of' })}
          noDataText={intl.formatMessage({ id: 'table.noDataText' })}
        />
      </main>
    );
  }
}

export default injectIntl(EmailsPage);
